import { Character } from '../../../dorian-shared/types/character/Character';

export const createGroupsWithCharacters = (characters: Array<Character>) => Array.from(
  new Set(characters.map((character) => character.group)),
);
